import "./experience.page.scss";

const Experience = () => {
  return <div className="experience-container">Page: Experience</div>;
};

export default Experience;
